<script setup lang="ts">
import { vElementVisibility } from '@vueuse/components';
import BrandsSubList from './BrandsSubList.vue';

interface BrandsList {
	initialsGroup: string[];
	activePill: number | undefined;
	showAlphabets: boolean;
}
const props = defineProps<BrandsList>();
const checkSticky = inject('checkSticky') as (
	state: boolean,
	brandInitial: string,
) => void;

const updateSelectedGroup = inject('updateSelectedGroup') as (
	brandInitial: string,
) => void;
const onElementVisibility = (state: boolean, brandInitial: string) => {
	if (props.showAlphabets) {
		checkSticky(state, brandInitial);
		updateSelectedGroup(brandInitial);
	}
};
</script>
<template>
	<div class="max-w-full overflow-x-hidden">
		<div v-if="initialsGroup.length !== 0">
			<div
				v-for="(brandInitial, index) in initialsGroup"
				:id="brandInitial"
				:key="index"
				v-element-visibility="[
					(state: boolean) => onElementVisibility(state, brandInitial),
					{
						threshold: 0.1,
					},
				]"
				:v-el="brandInitial"
				class="flex flex-col items-start"
				:class="showAlphabets ? 'py-3xl' : 'py-none'"
			>
				<p
					v-if="showAlphabets"
					:id="brandInitial as string"
					class="text-gray-400 text-center text-2xl font-bold"
				>
					{{ brandInitial }}
				</p>
				<BrandsSubList
					:brand-initial="brandInitial"
					:active-pill="activePill"
				/>
			</div>
		</div>
		<BrandsSubList
			v-else
			:active-pill="activePill"
			class="flex flex-col items-start"
		/>
	</div>
</template>
